<template>
  <div class="header_height" :class="{ isHeightReplace: isFixedBar
}">
    <RemindText :class="{ isRemindDisablie: isFixedBar}" />
    <header class="clientsHeader " :class="{ fixed_header: isFixedBar, fadeIn_header: isheaderFadeIn}">
      <div class="container client_container">
        <div class="top_flex">
          <div class="top_title">
            <router-link :to="{path:`/org/${cid}`}" class="top_link">
              <img v-if="clientIcon !== null" :src="clientIcon" class="client_icon"  alt="一刻鯨選">
              <h4 class="clients_title">{{ clientTitle }}</h4>
            </router-link>
          </div>

          <div class="top_tools">
            <div class="caption">
              <button class="caption_btn" @click="openModel">使用說明</button>
              <div class="caption_mobile_btn" @click="openModel">
                <img src="@/assets/images/clients/icon_info_filled.svg" class="caption_icon" alt="服務說明">
              </div>
              <!-- @click="toggleCaptionBar"  -->
            </div>
            <div class="jinfm_icon">
              <img src="@/assets/images/clients/logo_jin_pc.png" alt="logo_jin_pc" class="jinfm_icon_pc">
              <img src="@/assets/images/clients/logo_jin_mobile.png" alt="logo_jin_mobile" class="jinfm_icon_mobile">
            </div>
            <!--會員功能規劃中，之後會再改-->
            <!-- <div>
              <a class="login" href="javascript:;">登入</a>
            </div> -->
            <!--會員功能規劃中，之後會再改 end-->
          </div>
        </div>
      </div>

      <transition name='fade'>
        <div class="caption_modal" v-show="openCaption">
          <div class="caption_wrap">
            <div class="caption_group">
              <div class="caption_close">
                <button type="button" class="close_btn" @click="closeCaption">
                  <img src="@/assets/images/btn_close.png" class="close_icon" alt="close_icon">
                </button>
              </div>
              <div class="caption_logo" v-if="clientsLogo !== null">
                <img :src="clientsLogo" alt="caption_logo">
              </div>
              <div v-html="clientDescription" class="client_description"/>
            </div>
          </div>

          <div class='client_overlay' @click="closeCaption"></div>
        </div>
      </transition>
    </header>
  </div>
</template>
<script>
/* eslint-disable no-undef */
/* eslint eqeqeq: "off" */
import { mapState, mapGetters } from 'vuex'
import RemindText from '../components/RemindText'

export default {
  name: 'ClientsHeader',
  components: {
    RemindText
  },
  data () {
    return {
      openCaption: false,
      isIOS: false,
      scrollTopPos: 150,
      isFixedBar: false,
      isheaderFadeIn: false
    }
  },
  computed: {
    ...mapState({
      cid: state => state.toB.cid,
      clientIcon: state => state.toB.clientIcon,
      clientTitle: state => state.toB.clientTitle,
      clientDescription: state => state.toB.clientDescription
    }),
    ...mapGetters('toB', [
      'clientsLogo'
    ])
  },
  watch: {
    '$route.meta.headerFixed': {
      handler: function (val) {
        if (val === false) {
          this.isFixedBar = false
          this.setScrollListener()
        } else {
          this.isFixedBar = true
          this.removeScrollListener()
        }
      },
      // deep: true,
      immediate: true
    }
  },
  created () {
  },
  mounted () {
    if (this.$route.meta.headerFixed === false) {
      this.setScrollListener()
    } else {
      this.removeScrollListener()
      this.isFixedBar = true
    }
  },
  methods: {
    // 切換Scroll效果
    stopScroll (val) {
      if (val) {
        this.$modalHelper.afterOpen()
      } else {
        this.$modalHelper.beforeClose()
      }
    },
    openModel () {
      this.openCaption = true
      this.stopScroll(true)
    },
    closeCaption () {
      this.openCaption = false
      this.stopScroll(false)
    },
    getClientdata (id) {
      this.axios
        .get(`${this.$store.getters.baseURL}clients/${id}`)
        .then(response => {
          this.$store.commit('CLIENTS_TITLE', response.data.display_name)
          this.$store.commit('CLIENTS_DESCRIPTION', response.data.description)
          this.$store.commit('CLIENTS_ASSETS', response.data.client_blocks[0].client_assets)
        })
        .catch(error => console.log('log:' + error))
    },
    setScrollListener () {
      window.addEventListener('scroll', this.setScrollBarFixed)
    },
    removeScrollListener () {
      window.removeEventListener('scroll', this.setScrollBarFixed)
    },
    setScrollBarFixed () {
      if (window.pageYOffset > this.scrollTopPos) {
        this.isFixedBar = true
        this.isheaderFadeIn = true
      } else {
        this.isFixedBar = false
        this.isheaderFadeIn = false
      }
    }
  },
  beforeDestroy () {
    if (this.openCaption) {
      this.closeCaption()
    }
  }
  // beforeRouteLeave (to, from, next) {
  //   this.$modalHelper.beforeClose()
  //   next()
  // }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/clients.scss";

//header
.header_height {
  height: 113px;
}
.isHeightReplace {
  height: 75px;
}
.isRemindDisablie {
  display: none;
}
.top_flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 75px;
}
.top_link {
  text-decoration: none;
  color: #000;
  display: flex;
  align-items: center;
  > *:not(:last-child) {
    margin-right: 10px;
  }
  @media screen and (min-width: 767px) {
    > *:not(:last-child) {
      margin-right: 13px;
    }
  }
}

.top_title {
  flex: 1 1 auto;
}

.client_icon{
  width: 40px;
}
.clients_title {
  margin: 0;
  font-size: 22px;
  line-height: 30px;
  opacity: 0;
  @include ellipsis(1)
}

.fixed_header {
  background: #fff;
  box-shadow: 0 4px 17px 0 rgba(0,0,0,0.1);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 999;
  .client_icon{
    width: 45px;
  }
  .clients_title {
    opacity: 1;
  }
}

.top_tools {
  min-width: 120px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.caption_btn {
  color: $main_color;
  background: #fff;
  font-weight: 600;
  border: 1px solid rgba(23, 109, 140, 0.1);
  border-radius: 10px;
  padding: 8px 16px;
  font-size: 16px;
  display: none;
}

.caption_mobile_btn {
  padding: 10px;
  .caption_icon {
    width: 25px;
  }
}

.jinfm_icon {
  margin-left: 10px;
  position: relative;
  &::before{
    content: "";
    width: 4px;
    height: 28px;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 26px;
    color: #176E8D;
    opacity: 0.5;
    position: absolute;
    left: 0;
  }
  .jinfm_icon_pc {
      display: none;
    }
    .jinfm_icon_mobile {
      display: inline-block;
    }
}

@media screen and (min-width: 576px) {
  .caption_btn {
    display: inline-block;
  }

  .caption_mobile_btn {
    display: none;
  }
  .top_tools {
    min-width:  250px;
    .jinfm_icon {
      margin-left: 20px;
      padding-left: 20px;
      &::before{
        content: "|";
      }
      .jinfm_icon_pc {
        display: inline-block;
      }
      .jinfm_icon_mobile {
        display: none;
      }
    }
  }

}

@media screen and (min-width: 767px) {
  .header_height {
    height: 96px;
  }
  .client_icon{
    width: 75px;
  }
  .clients_title {
    font-size: 32px;
    line-height: 45px;
  }
  .top_flex {
    height: 96px;
    margin-top: 20px;
  }
  .fixed_header .top_flex {
    margin-top: 0;
  }
}
//header END

//Caption_Modal
.caption_logo {
  margin-top: 10px;
  margin-bottom: 30px;
}

.caption_modal {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding-top: 0px;
  z-index: 3;
}

.caption_close {
  text-align: right;
  .close_btn {
    text-shadow: 0 1px 0 #fff;
    cursor: pointer;
    padding: 0;
    background-color: transparent;
    border: 0;
  }
  .close_icon {
    width: 20px;
  }
}

.caption_wrap {
  margin: auto;
  width: 100%;
  height: 100%;
  border-radius: 0;
  background-color: #fff;
  overflow: hidden;
}

.caption_group {
  position: relative;
  z-index: 3;
  padding: 25px 35px 45px;
  height: 100vh;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 5px;
    height: 7px;
    padding-right: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgb(219, 220, 221);
    border: 0px none #ffffff;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    border: 0px none #ffffff;
    border-radius: 50px;
  }
  .client_description {
    >>> h2 {
      font-size: 24px;
      line-height: 33px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    >>> p {
      font-size: 16px;
      line-height: 26px;
      margin-bottom: 30px;
    }
  }
}

.client_overlay {
  position: fixed;
  left: 0;
  top: 0;
  background: rgba(0,0,0,.65);
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: -1;
}

.fade-enter-active {
  transition: opacity .8s
}

.fade-leave-active {
  transition: opacity .4s
}

.fade-enter,.fade-leave-to {
  opacity: 0;
}

.fadeIn_header{
  animation: fadeIn 1s;
}

/*頭像動畫*/
@-webkit-keyframes fadeIn{
  0% { opacity: 0 }
  50%{ opacity: 0.5 }
  100%{ opacity: 1}
}

@keyframes fadeIn{
  0% { opacity: 0 }
  50%{ opacity: 0.5 }
  100%{ opacity: 1}
}

@media screen and (min-width: 576px){
  .caption_modal {
    padding: 100px 0;
  }
  .caption_wrap {
    border-radius: 10px;
    width: 450px;
  }
  .caption_group {
    height: calc(100vh - 200px);
    padding: 25px 35px;
  }
}
//Caption_Modal END
</style>



// WEBPACK FOOTER //
// src/components/views/clients/components/ClientsHeader.vue